export default __webpack_public_path__ + "static/media/answers_meter_placeholder.8bca53cb.png";